import { render } from "./index.vue?vue&type=template&id=36e3fe9a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/online-shop-banners-add/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36e3fe9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36e3fe9a', __exports__)) {
    api.reload('36e3fe9a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=36e3fe9a", () => {
    api.rerender('36e3fe9a', render)
  })

}


export default __exports__